(function () {
  'use strict';

  // Accumulate directional movement so touchpad jitter does not flash the header.
  function createScrollState(initialY = 0) {
    let previousY = initialY;
    let direction = 0;
    let distance = 0;
    let hidden = false;
    return function update(y, height, pinned = false) {
      y = Math.max(0, y);
      const delta = y - previousY;
      previousY = y;
      if (pinned || y <= height) {
        hidden = false;
        distance = 0;
        direction = 0;
        return hidden;
      }
      if (delta === 0) return hidden;
      const nextDirection = Math.sign(delta);
      distance = nextDirection === direction ? distance + Math.abs(delta) : Math.abs(delta);
      direction = nextDirection;
      if (direction > 0 && distance >= 16) hidden = true;
      if (direction < 0 && distance >= 8) hidden = false;
      return hidden;
    };
  }
  if (typeof module === 'object' && module.exports) module.exports = { createScrollState };
  if (typeof document === 'undefined') return;

  const header = document.querySelector('[data-azure-header]');
  if (!header) return;
  const dialogs = [...document.querySelectorAll('[data-azure-dialogs] dialog')];
  const categoryMenus = [...document.querySelectorAll('.azure-shell [data-category-menu]')];
  const scrollState = createScrollState(window.scrollY);
  let headerHeight = header.offsetHeight;
  let framePending = false;

  function reveal() { header.removeAttribute('data-hidden'); }
  function pinned() {
    return header.contains(document.activeElement) ||
      Boolean(header.querySelector('[aria-expanded="true"], details[open]')) ||
      dialogs.some(dialog => dialog.open);
  }
  function updateHeader() {
    framePending = false;
    header.toggleAttribute('data-hidden', scrollState(window.scrollY, headerHeight, pinned()));
  }
  function scheduleHeader() {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(updateHeader);
  }
  new ResizeObserver(() => {
    headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty('--ab-header-height', headerHeight + 'px');
    scheduleHeader();
  }).observe(header);
  window.addEventListener('scroll', scheduleHeader, { passive: true });
  window.addEventListener('pageshow', scheduleHeader);
  header.addEventListener('focusin', reveal);

  function setCategory(button, expanded) {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    button.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
    if (expanded) reveal();
  }
  function closeCategories(except) {
    categoryMenus.forEach(menu => menu.querySelectorAll('[data-category-toggle]').forEach(button => {
      if (button !== except) setCategory(button, false);
    }));
  }
  categoryMenus.forEach(menu => {
    menu.querySelectorAll('[data-category-toggle]').forEach(button => {
      button.addEventListener('click', () => {
        const expand = button.getAttribute('aria-expanded') !== 'true';
        closeCategories(button);
        setCategory(button, expand);
      });
      button.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        closeCategories(button);
        setCategory(button, true);
        document.getElementById(button.getAttribute('aria-controls'))?.querySelector('a')?.focus();
      });
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const button = menu.querySelector('[data-category-toggle][aria-expanded="true"]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      setCategory(button, false);
      button.focus();
    });
    menu.addEventListener('focusout', event => {
      const item = event.target.closest('[data-category-item]');
      if (item && !item.contains(event.relatedTarget)) {
        const button = item.querySelector('[data-category-toggle]');
        if (button) setCategory(button, false);
      }
    });
  });
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.azure-shell [data-category-item]')) closeCategories();
  });

  const openers = new Map();
  header.querySelectorAll('[data-open]').forEach(button => {
    const dialog = dialogs.find(item => item.id === button.dataset.open);
    if (!dialog) return;
    button.setAttribute('aria-controls', dialog.id);
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      closeCategories();
      openers.set(dialog, button);
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ab-navigation-open');
      reveal();
      dialog.showModal();
      if (dialog.id === 'search-dialog' && window.matchMedia('(min-width:801px)').matches) {
        dialog.querySelector('input[type=search]')?.focus();
      }
    });
  });
  dialogs.forEach(dialog => {
    dialog.querySelector('[data-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const opener = openers.get(dialog);
      opener?.setAttribute('aria-expanded', 'false');
      if (!dialogs.some(item => item.open)) document.body.classList.remove('ab-navigation-open');
      closeCategories();
      opener?.focus();
    });
  });

  // Retain Horizon's drawer and add-to-cart behavior on its native page layouts.
  header.querySelector('[data-azure-cart]')?.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const nativeTrigger = document.querySelector('.azure-cart-support [data-testid="cart-drawer-trigger"]');
    if (!nativeTrigger) return;
    event.preventDefault();
    nativeTrigger.click();
  });
  window.lucide?.createIcons();
  updateHeader();
})();
